import { useMutation } from "react-query";
import api from "../../client";
import {
  CreateInstitutionPayload,
  InstitutionDetailResponseData,
} from "../../types/institution";

const postData = async (
  payload: CreateInstitutionPayload,
): Promise<InstitutionDetailResponseData> => {
  const { data } = await api.post(`/institutions`, payload);

  return data;
};

export const useCreateInstitution = () => {
  return useMutation((payload: CreateInstitutionPayload) => {
    return postData(payload);
  });
};
